<template>
  <div>
    <div class="top">
      <div class="searchBox">
        <van-field
          v-model="card"
          class="inputBox"
          label
          placeholder="请输入检测卡号"
        />
        <el-button class="searchBtn" @click="selfHelp">自助检测</el-button>
      </div>
    </div>
    <div v-show="result == 1">
      <div class="content-top">诊断结果</div>
      <div class="content">
        <div class="item">
          <div style="width: 33%">1.{{ zhenduan.cardState_0 }}</div>
          <div style="width: 33%">
            <div v-if="zhenduan.cardState_1 == -1">未知</div>
            <div v-if="zhenduan.cardState_1 == 0">正常</div>
            <div v-if="zhenduan.cardState_1 == 1">单项停机</div>
            <div v-if="zhenduan.cardState_1 == 2">停机</div>
            <div v-if="zhenduan.cardState_1 == 3">预销号</div>
            <div v-if="zhenduan.cardState_1 == 4">销号/拆机</div>
            <div v-if="zhenduan.cardState_1 == 5">过户</div>
            <div v-if="zhenduan.cardState_1 == 6">休眠</div>
            <div v-if="zhenduan.cardState_1 == 7">待激活</div>
            <div v-if="zhenduan.cardState_1 == 8">已停用</div>
            <div v-if="zhenduan.cardState_1 == 9">库存</div>
            <div v-if="zhenduan.cardState_1 == 10">已失效</div>
            <div v-if="zhenduan.cardState_1 == 11">违章停机</div>
            <div v-if="zhenduan.cardState_1 == 12">挂失</div>
            <div v-if="zhenduan.cardState_1 == 13">用户报停</div>
            <div v-if="zhenduan.cardState_1 == 14">不存在</div>
            <div v-if="zhenduan.cardState_1 == 15">低速</div>
          </div>
          <div
            :class="zhenduan.cardState_2 == '正常' ? 'grann' : 'red'"
            style="width: 33%"
          >
            {{ zhenduan.cardState_2 }}
          </div>
        </div>

        <div class="item">
          <div style="width: 33%">2.{{ zhenduan.cardSumFlow_0 }}</div>
          <div style="width: 33%">
            {{ zhenduan.cardSumFlow_1 }}
          </div>
          <div
            :class="zhenduan.cardSumFlow_2 == '正常' ? 'grann' : 'red'"
            style="width: 33%"
          >
            {{ zhenduan.cardSumFlow_2 }}
          </div>
        </div>

        <div class="item">
          <div style="width: 33%">3.{{ zhenduan.cardConsumeFlow_0 }}</div>
          <div style="width: 33%">
            {{ zhenduan.cardConsumeFlow_1 }}
          </div>
          <div
            :class="zhenduan.cardConsumeFlow_2 == '正常' ? 'grann' : 'red'"
            style="width: 33%"
          >
            {{ zhenduan.cardConsumeFlow_2 }}
          </div>
        </div>

        <div class="item">
          <div style="width: 33%">4.{{ zhenduan.cardSurplusFlow_0 }}</div>
          <div style="width: 33%">
            {{ zhenduan.cardSurplusFlow_1 }}
          </div>
          <div
            :class="zhenduan.cardSurplusFlow_2 == '正常' ? 'grann' : 'red'"
            style="width: 33%"
          >
            {{ zhenduan.cardSurplusFlow_2 }}
          </div>
        </div>
        <div class="item">
          <div style="width: 33%">5.{{ zhenduan.cardOfficialRealName_0 }}</div>
          <div style="width: 33%">
            {{ zhenduan.cardOfficialRealName_1 }}
          </div>
          <div
            :class="zhenduan.cardOfficialRealName_2 == '正常' ? 'grann' : 'red'"
            style="width: 33%"
          >
            {{ zhenduan.cardOfficialRealName_2 }}
          </div>
        </div>

        <div class="item">
          <div style="width: 33%">6.{{ zhenduan.cardEndTime_0 }}</div>
          <div style="width: 33%">
            {{ zhenduan.cardEndTime_1 }}
          </div>
          <div
            :class="zhenduan.cardEndTime_2 == '正常' ? 'grann' : 'red'"
            style="width: 33%"
          >
            {{ zhenduan.cardEndTime_2 }}
          </div>
        </div>
        <div style="margin-top: 10px" @click="quick">
          <van-notice-bar
            v-if="
              zhenduan.cardResult_3 == 0 ||
              zhenduan.cardResult_3 == 1 ||
              zhenduan.cardResult_3 == 2
            "
            color="#FF0000"
            background="#FFDDDD"
            left-icon="close"
          >
            {{
              zhenduan.cardResult_3 == 0
                ? zhenduan.cardResult_1 + "，点击此处快速充值套餐"
                : zhenduan.cardResult_3 == 1
                ? zhenduan.cardResult_1 + "，点击此处快速复机"
                : zhenduan.cardResult_3 == 2
                ? zhenduan.cardResult_1 + "，点击此处去实名"
                : ""
            }}
          </van-notice-bar>
          <van-notice-bar
            v-else
            color="#1989fa"
            background="#ecf9ff"
            left-icon="passed"
          >
            {{ zhenduan.cardResult_1 }}
          </van-notice-bar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { autoTestCard, start } from "@/api/cardOperation";

  export default {
    data() {
      return {
        //检测卡号
        card: "",
        //检测详情
        zhenduan: {},
        //检测结果
        result: 0,
      };
    },
    created() {},
    async mounted() {
      await this.dialog();
    },
    methods: {
      //弹窗提示
      dialog() {
        this.$dialog
          .alert({
            title: "温馨提示",
            message: "输入充值卡号，点击自助检测，等待结果即可！",
          })
          .then(() => {
            // on close
          });
      },
      //执行复机
      start() {
        var ssex = this.$toast.loading({
          message: "正在执行复机...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0,
        });
        start(this.card)
          .then((res) => {
            if (res.status) {
              ssex.clear();
              this.$toast(res.msg);
              this.autoTestCard(this.card);
            }
          })
          .catch(() => {});
        //     });
        // });
      },
      //快捷操作
      quick() {
        if (this.zhenduan.cardResult_3 == 0) {
          this.$router.push(`/about`);
        } else if (this.zhenduan.cardResult_3 == 1) {
          this.start();
        } else if (this.zhenduan.cardResult_3 == 2) {
          this.$router.push(`/home`);
        }
      },
      //自助检测
      async selfHelp() {
        this.result = 0;
        var loading = this.$toast.loading({
          message: "智能检测中...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0,
        });
        await this.autoTestCard(this.card);
        await loading.clear();
      },
      //智能检测
      autoTestCard(val) {
        autoTestCard(val).then((res) => {
          if (res.status) {
            localStorage.setItem("card", val);
            localStorage.setItem("meCardNum", val);
            this.zhenduan = res.data;
            console.log(this.zhenduan.cardResult_3);
            this.result = 1;
          } else {
            this.$dialog
              .alert({
                title: "提示",
                message: res.msg,
              })
              .then(() => {
                // on close
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .top {
    box-sizing: border-box;
    padding: 20px 10px 20px 7px;
  }

  .grann {
    color: green;
  }

  .red {
    color: red;
  }
  .item {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #c4c4c4;
  }
  .content {
    font-size: 12px;
  }
  .content-top {
    height: 38px;
    font-size: 13px;
    color: #fff;
    line-height: 38px;
    background: #77baff;
    border-radius: 19px 19px 0 0;
  }
  .searchBox {
    display: flex;
    width: 100%;
    height: 38px;
    border-radius: 5px;
    border: 1px solid #1b8bff;

    .inputBox {
      width: calc(100% - 1.8rem);
      height: 40px;
      line-height: 40px;
      border: none;
      background: transparent;
      border-radius: 15px;
      overflow: hidden;
      padding: 0px 0.133rem;
    }
  }
  .searchBtn {
    justify-content: end;
    height: 42px;
    text-align: center;
    margin-top: -2px;
    margin-right: -5px;
    border-radius: 5px;
    background: linear-gradient(45deg, #75b9ff, #1b8bff);
    overflow: hidden;
    color: #fff;
    font-size: 12px;
  }
</style>
